// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.in-game-notification-container {
    pointer-events: none;
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 0.5%;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 0.5rem;
}

.in-game-notification {
    flex: 0 0 auto;
    width: fit-content;
    max-width: min(var(--max-width), 80%);
    background-color: #4f4f4f;
    color: white;
    opacity: 95%;
    padding: 1rem;
    border-radius: 0.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    text-align: center;
    z-index: 10000;
}`, "",{"version":3,"sources":["webpack://./src/InGameNotifications.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".in-game-notification-container {\n    pointer-events: none;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    top: 0.5%;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    gap: 0.5rem;\n}\n\n.in-game-notification {\n    flex: 0 0 auto;\n    width: fit-content;\n    max-width: min(var(--max-width), 80%);\n    background-color: #4f4f4f;\n    color: white;\n    opacity: 95%;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    font-size: 1.1rem;\n    font-weight: 500;\n    text-align: center;\n    z-index: 10000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
